module.exports = __webpack_public_path__ + "resources/img/m-pic-03.d08cdaea.jpg";